/**
 * Short relative age for worklist rows ("12 min", "3 h", "2 d"). Returns the i18n key and
 * the value; the caller renders t(key, { n }).
 */
export function relativeAge(iso: string | null | undefined, now: Date): { key: string; n: number } | null {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return null;
  const diffMin = Math.max(0, Math.round((now.getTime() - then) / 60_000));
  if (diffMin < 60) return { key: "common.ageMinutes", n: diffMin };
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return { key: "common.ageHours", n: diffH };
  return { key: "common.ageDays", n: Math.floor(diffH / 24) };
}
